<template>
    <a
        v-bind="$attrs"
        :href="href"
        :target="formattedTarget"
        @click="sendToRoute">
        <slot />
    </a>
</template>

<script>
import { isNavigationFailure, NavigationFailureType } from 'vue-router';
import { eventIsOpeningANewTabOrWindow } from '@/utils/window.utils.js';

function isIgnorableNavigationFailure (failure) {
    return (
        isNavigationFailure(failure, NavigationFailureType.duplicated) ||
        isNavigationFailure(failure, NavigationFailureType.cancelled)
    );
}

export default {
    name: 'PendoRouterLink',
    inheritAttrs: false,
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    props: {
        to: {
            type: [String, Object],
            default: undefined,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        target: {
            type: String,
            default: '_self',
        },
        external: {
            type: Boolean,
            default: false,
        },
        replace: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['navigation-failed'],
    computed: {
        href () {
            if (this.to == null || this.disabled) {
                return null;
            }

            if (this.external) {
                return this.to;
            }

            try {
                return this.$router.pendo.toPath(this.to);
            } catch (err) {
                console.error('Unable to resolve route in pendo-router-link', this.to, err.message);

                return '';
            }
        },
        formattedTarget () {
            return this.target === '_blank' ? '_blank' : null;
        },
    },
    methods: {
        sendToRoute ($event) {
            if (!this.href || this.formattedTarget === '_blank' || eventIsOpeningANewTabOrWindow($event)) return;

            // in vue-router 4, <a> tags will cause a full page reload - don't let them
            // do their normal behavior and we'll use $router.push instead
            $event.preventDefault();

            const navigation = this.replace
                ? this.$router.replace(this.href)
                : this.$router.push(this.href);

            navigation.catch((failure) => {
                if (isIgnorableNavigationFailure(failure)) return;

                console.error('Navigation failed in pendo-router-link', this.href, failure);
                this.$emit('navigation-failed', {
                    failure,
                    href: this.href,
                    to: this.to,
                });
            });
        },
    },
};
</script>
